<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 71.1 76"
  >
<g id="logo">
    <g id="logo_1_">
        <g>
            <ellipse fill="#2F84ED" cx="36" cy="38.3" rx="33.1" ry="34.1"/>
        </g>
    </g>
</g>
<g>
    <polygon fill="#FFFFFF" points="17.5,25.1 21.4,25.1 24.4,30.6 27.3,25.1 31,25.1 26.1,33.9 26.1,38.6 22.5,38.6 22.5,34  "/>
    <path fill="#FFFFFF" d="M29.9,31.9c0-4.1,3.3-6.9,7.1-6.9c3.8,0,7.1,2.9,7.1,6.9c0,4.1-3.3,7-7.1,7C33.2,38.8,29.9,36,29.9,31.9    M40.4,31.9c0-2.1-1.3-3.8-3.5-3.8c-2.2,0-3.5,1.7-3.5,3.8c0,2.1,1.3,3.8,3.5,3.8C39.2,35.7,40.4,34,40.4,31.9"/>
    <polygon fill="#FFFFFF" points="47.4,28.1 43.9,28.1 43.9,25.1 54.5,25.1 54.5,28.1 51,28.1 51,38.6 47.4,38.6  "/>
    <path fill="#FFFFFF" d="M22.1,53.4h-3.5V39.9h5c3.6,0,5.6,2.3,5.6,5.3c0,3-2,5.3-5.6,5.3h-1.5V53.4z M23.4,47.4   c1.6,0,2.2-0.9,2.2-2.2c0-1.3-0.6-2.3-2.2-2.3h-1.3v4.5H23.4z"/>
    <path fill="#FFFFFF" d="M29.8,46.7c0-4.1,3.3-6.9,7.1-6.9c3.8,0,7.1,2.9,7.1,6.9c0,4.1-3.3,7-7.1,7C33.1,53.6,29.8,50.8,29.8,46.7    M40.4,46.7c0-2.1-1.3-3.8-3.5-3.8c-2.2,0-3.5,1.7-3.5,3.8c0,2.1,1.3,3.8,3.5,3.8C39.1,50.5,40.4,48.8,40.4,46.7"/>
    <path fill="#FFFFFF" d="M44,51.7c0-1.2,0.9-2,1.9-2c1,0,1.9,0.8,1.9,2c0,1.2-0.9,2-1.9,2C44.9,53.6,44,52.8,44,51.7"/>
</g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'YotpoLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
